import {
  Button,
  FormControl,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { KeyboardEvent, useEffect, useState } from "react";
import { BootstrapInput } from "src/@shared";
import { ModalComponent } from "./ModalComponent";
// import { nicknameResultHandler } from "src/handlers/nicknameResultHandler";
import { useTranslation } from "react-multi-lang";
import { useSelector } from "react-redux";
import { messageEvents } from "src/@types";
import { globalVars } from "src/data/globals";
import { nicknameRequestHandler } from "src/handlers/nicknameRequestHandler";
import { nicknameResultHandler } from "src/handlers/nicknameResultHandler";
import { eventSender } from "src/listeners/messageListener";
import store, { getPlayer } from "src/store/store";

export const NicknameModal = () => {
  const t = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const isRtl = store.getState().config.config.lang.rtl;
  const [errorMessage, setErrorMessage] = useState("");
  const name: string | undefined = useSelector(getPlayer)?.player?.nickname;
  const [nickname, setNickname] = useState<string>(name ? name : "");

  const sendData = () => {
    if (nickname.length < 1) {
      setErrorMessage("Min characters 1");
    } else if (nickname.length > 128) {
      setErrorMessage("Max characters 128");
      //  } else {
      //     webSocketSender({ nickname: nickname }, 'setNickname')
    }

    if (globalVars.isOffline) {
      //-- for demo purposes only 2023-06-21
      nicknameResultHandler({ nickname });
    } else {
      nicknameRequestHandler(nickname);
    }
    eventSender(messageEvents.GAMESTART, {});
    globalVars.player.nickname = nickname;
    setOpen(!open);
  };
  const handleNickname = (
    e: KeyboardEvent<HTMLInputElement> & { target: HTMLInputElement }
  ) => {
    setNickname(e.target.value);
  };

  useEffect(() => {
    setOpen(!nickname);
    // eslint-disable-next-line
  }, []);

  return (
    <ModalComponent
      open={open}
      height={"169px"}
      width={"370px"}
      radius={8}
      sx={{ overflowY: "hidden" }}
    >
      <Stack p={2} direction={"column"} sx={{ overflowY: "hidden" }}>
        <FormControl fullWidth variant="standard">
          <InputLabel
            sx={{
              color: "#837C9C",
              fontSize: "12px",
              fontWeight: 300,

              textAlign: isRtl ? "right" : "left",
              width: "100vw",
            }}
            shrink
            htmlFor="bootstrap-input"
          >
            {t("translate.enter_name")}
          </InputLabel>
          <BootstrapInput
            onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
              e.key === "Enter" ? sendData() : null
            }
            onChange={handleNickname}
            value={nickname || ""}
            fullWidth
            id="bootstrap-input"
            inputProps={{
              maxLength: 25,
              minLength: 1,
              style: { textTransform: "lowercase" },
              dir: isRtl ? "rtl" : "ltr",
            }}
          />
          <Typography
            m={0.2}
            variant={"caption"}
            sx={{
              fontFamily: "Nunito Sans,sans-serif !important",
              fontSize: "12px",
            }}
            id="errorMessage"
          >
            {errorMessage}
          </Typography>
        </FormControl>

        <Button
          sx={{ mt: 2, border: "none" }}
          variant={"contained"}
          fullWidth
          onClick={sendData}
          // type="submit"
        >
          {t("translate.submit")}
        </Button>
      </Stack>
    </ModalComponent>
  );
};
